/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useMemo } from 'react';
import { useMutation } from '@apollo/client';
import styled from 'styled-components';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  FormControlLabel,
  Switch,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import DeleteOutlinedOutlined from '@material-ui/icons/DeleteOutlineOutlined';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { DeleteOpFirm } from '../../../../../components/mutations';
import { useColors } from '../../../../../hooks';
import { OpFirmProfileDialog } from './opFirmProfile';

export interface CreditorProps {
  opFirms?: any;
}

const defaultProps = {
  opFirms: [],
};

const StyledDiv = styled.div<{ borderColor: string }>`
  overflow: hidden;
  border-top: 8px solid ${({ borderColor }): string => borderColor};
`;
export const OpposingFirms: React.FC<CreditorProps> = ({ opFirms }) => {
  const { themeColors } = useColors();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState<string>('');
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(localStorage.getItem('profileRowsPerPage') as string, 10) || 5,
  );

  // -------------------------------------delete op party -------------------------------------
  const [opId, setOpId] = useState(null);
  const [deleteTitle, setDeleteTitle] = useState(null);
  const [deleteOpFirm] = useMutation(DeleteOpFirm, {
    variables: { opFirmId: opId },
  });
  // Modal Logic
  const [open, setOpen] = React.useState(false);
  const handleClose = (): void => {
    setOpen(false);
  };
  const handleCloseAgree = (): void => {
    setOpen(false);
    deleteOpFirm();
  };
  const handleClickOpen = (ID, TITLE): void => {
    setOpen(true);
    setOpId(ID);
    setDeleteTitle(TITLE);
  };
  const handleSearch = (e): void => {
    setSearch(e.target.value);
  };
  // -------------------------------------end delete op party ----------------------------------
  const [openOpFirmProfile, setOpenOpFirmProfile] = useState(false);
  const handleOpenOpFirmProfile = (ID): void => {
    setOpenOpFirmProfile(true);
    setOpId(ID);
  };
  const handleCloseOpFirmProfile = (): void => {
    setOpenOpFirmProfile(false);
  };
  useEffect(() => {
    if (localStorage.getItem('profileTableDense') === 'dense') {
      setDense(true);
    }
    if (localStorage.getItem('profileTableDense') === 'notDense') {
      setDense(false);
    }
    localStorage.setItem('profileRowsPerPage', rowsPerPage.toString());
  }, []);

  const handleChangeDense = (event: {
    target: { checked: React.SetStateAction<boolean> };
  }): void => {
    setDense(event.target.checked);
    if (event.target.checked) {
      localStorage.setItem('profileTableDense', 'dense');
    }
    if (!event.target.checked) {
      localStorage.setItem('profileTableDense', 'notDense');
    }
  };

  const handleChangePage = (
    _event: unknown,
    newPage: React.SetStateAction<number>,
  ): void => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: {
    target: { value: string };
  }): void => {
    setRowsPerPage(parseInt(event.target.value, 10));
    localStorage.setItem('profileRowsPerPage', event.target.value);
    setPage(0);
  };
  return (
    <>
      <StyledDiv borderColor={themeColors.mainColors.primaryColor}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
          component="div"
          count={opFirms?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'previous page',
          }}
          nextIconButtonProps={{
            'aria-label': 'next page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          style={{ float: 'right' }}
        />

        <div
          style={{
            float: 'left',
            marginBottom: -10,
            marginTop: 7,
            marginLeft: 15,
          }}
        >
          <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} />}
            label="Dense padding"
          />
          <TextField
            id="input-with-icon-search"
            onChange={handleSearch}
            placeholder="Search"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </StyledDiv>
      <div
        style={{
          borderTop: `2px solid ${themeColors.mainColors.primaryColor}`,
        }}
      />
      <Table aria-label="simple table" size={dense ? 'small' : 'medium'}>
        <TableHead>
          <TableRow style={{}}>
            <TableCell align="left">
              <Typography color="secondary">Name</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Open Cases</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Phone</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Fax</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Location</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Delete</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {opFirms
            .filter(x =>
              x.op_firm_name
                .toLowerCase()
                .includes(search?.toLowerCase() || ''),
            )
            .sort((a, b) => a.op_firm_name.localeCompare(b.op_firm_name))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(
              ({
                op_firm_id,
                op_firm_name,
                op_firm_phone,
                op_firm_fax,
                op_firm_address1,
                op_firm_address2,
                op_firm_address_city,
                op_firm_address_state,
                op_firm_address_zip,
                matters,
              }) => (
                <TableRow
                  key={op_firm_id}
                  hover
                  onClick={(): void => handleOpenOpFirmProfile(op_firm_id)}
                  style={{ cursor: 'pointer' }}
                >
                  <>
                    <TableCell component="th" scope="row">
                      {op_firm_name}
                    </TableCell>
                    <TableCell align="left">{matters?.length}</TableCell>
                    <TableCell align="left">{op_firm_phone}</TableCell>
                    <TableCell align="left">{op_firm_fax}</TableCell>
                    <TableCell align="left">
                      {op_firm_address1 &&
                        `${op_firm_address1 || ''}, ${(op_firm_address2 &&
                          `${op_firm_address2}, `) ||
                          ''}${op_firm_address_city ||
                          ''}, ${op_firm_address_state ||
                          ''} ${op_firm_address_zip || ''}`}
                    </TableCell>
                    <TableCell align="left">
                      <DeleteOutlinedOutlined
                        color="primary"
                        onClick={(): void =>
                          handleClickOpen(op_firm_id, op_firm_name)
                        }
                      />
                    </TableCell>
                  </>
                </TableRow>
              ),
            )}
        </TableBody>
      </Table>

      <>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
          component="div"
          count={opFirms?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'previous page',
          }}
          nextIconButtonProps={{
            'aria-label': 'next page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          style={{ float: 'right' }}
        />
        <div
          style={{
            borderTop: `2px solid ${themeColors.mainColors.primaryColor}`,
          }}
        />
      </>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Firm?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete the firm {deleteTitle}? This action
            is permanent and cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            style={{ fontWeight: 'bold' }}
          >
            No, Cancel
          </Button>
          <Button
            onClick={handleCloseAgree}
            color="primary"
            autoFocus
            style={{ fontWeight: 'bold' }}
          >
            Yes, delete
          </Button>
        </DialogActions>
      </Dialog>
      {openOpFirmProfile && (
        <OpFirmProfileDialog
          open={openOpFirmProfile}
          handleClose={handleCloseOpFirmProfile}
          id={opId}
        />
      )}
    </>
  );
};

OpposingFirms.defaultProps = defaultProps;
